/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LanguageChangeRequestBody
 */
export interface LanguageChangeRequestBody {
    /**
     * 
     * @type {string}
     * @memberof LanguageChangeRequestBody
     */
    language: string;
}

export function LanguageChangeRequestBodyFromJSON(json: any): LanguageChangeRequestBody {
    return LanguageChangeRequestBodyFromJSONTyped(json, false);
}

export function LanguageChangeRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageChangeRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'language': json['language'],
    };
}

export function LanguageChangeRequestBodyToJSON(value?: LanguageChangeRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'language': value.language,
    };
}

